// Get all submenus (besides L1)
const allSubmenus = [];

// Get side menu container and its open/close button
const openNavBtn = document.querySelectorAll(".adm-btn-nav-mobile")?.[0];
const mobileLogoLink = document.querySelector(".adm-figure-nav-logo-mobile").firstElementChild;
const sideNavContainer = openNavBtn?.nextElementSibling;
const sideNavFirstLink = sideNavContainer?.querySelector(".adm-li-nav-mobile-link-container")?.firstElementChild;
const sideNavAllLinks = sideNavContainer.querySelectorAll("a");
const sideNavAllBtns = sideNavContainer.querySelectorAll("button");
const sideNavL2Containers = sideNavContainer.querySelectorAll(".adm-sidenav-l2");
let isSideNavCreated = false;

// Close/Open the side navigation menu
openNavBtn?.addEventListener("click", () => {
    if (sideNavContainer?.classList.contains("adm-ul-nav-mobile-opened")) {
        closeSideNavMobile();
    } else {
        openSideNavMobile();
    }
});

// Header tab key presses
openNavBtn?.addEventListener("keydown", event => {
    const pressedKeyCode = event.which || event.keyCode;
    if (!event.shiftKey && pressedKeyCode === 9) {
        event.preventDefault();
        mobileLogoLink?.focus();
    }
});

mobileLogoLink?.addEventListener("keydown", event => {
    const pressedKeyCode = event.which || event.keyCode;
    if (event.shiftKey && pressedKeyCode === 9) {
        event.preventDefault();
        openNavBtn?.focus();
    }
});

// Get all submenu link containers
const navLinkContainers = sideNavContainer.querySelectorAll('.adm-ul-dropdown-nav-menu-mobile li');

// Iterate through all submenu link containers
for (const navLinkContainer of navLinkContainers) {

    // Get the submenu link
    const navLink = navLinkContainer?.firstElementChild;

    // Get its parent and grandparent submenu containers
    const grandParentSubmenuContainer = navLink?.parentElement?.parentElement?.parentElement?.parentElement;
    const parentSubmenuContainer = navLink?.parentElement?.parentElement;

    // Check if it has submenu
    if (navLink?.getAttribute('aria-haspopup') && navLink?.nextElementSibling) {

        // Get child submenu and add to an array
        const childSubmenuContainer = navLink?.nextElementSibling;
        if (childSubmenuContainer) {
            allSubmenus?.push(childSubmenuContainer);
        }

        // Open submenu
        navLink?.addEventListener('click', () => {
            childSubmenuContainer?.classList.add("adm-ul-nav-mobile-opened");
            if (childSubmenuContainer) {
                childSubmenuContainer.children[1]?.firstElementChild.focus();
            }
        })
    }

    // Check if it is a "back" link
    if (navLink?.classList.contains('adm-btn-nav-mobile-back')) {

        // Closes submenu
        navLink?.addEventListener('click', () => {
            parentSubmenuContainer?.classList.remove("adm-ul-nav-mobile-opened");
            grandParentSubmenuContainer.style.overflow = '';
            parentSubmenuContainer.previousElementSibling?.focus();
        })
    }

    // Key press listener
    if (!navLink?.closest(".adm-ul-nav-mobile-l3")) {
        navLink?.addEventListener("keydown", event => {
            const pressedKeyCode = event.which || event.keyCode;

            // TAB key press
            if (pressedKeyCode === 9) {
                onTabKeypress(event)
            }

            // ESC key press
            if (pressedKeyCode === 27 && navLinkContainer?.parentElement.classList.contains("adm-ul-dropdown-nav-menu-mobile")) {
                event.preventDefault();
                closeSideNavMobile();
                openNavBtn.focus();
            } else if (pressedKeyCode === 27) {
                event.preventDefault();
                parentSubmenuContainer?.classList.remove("adm-ul-nav-mobile-opened");
                grandParentSubmenuContainer.style.overflow = '';
                setTimeout(() => {
                    navLinkContainer?.parentElement.previousElementSibling?.focus();
                }, 100);
            }
        })

        function onTabKeypress(event) {
            if (event.shiftKey && navLinkContainer?.previousElementSibling) {
                event.preventDefault();
                closeSubmenuOrFocusOnPreviousLink(event, navLinkContainer, parentSubmenuContainer, grandParentSubmenuContainer);
            }
            // Close entire menu after first link
            else if (
                event.shiftKey &&
                navLinkContainer?.parentElement.classList.contains("adm-ul-dropdown-nav-menu-mobile") &&
                !navLinkContainer?.previousElementSibling
            ) {
                closeSideNavMobile();
            }
            // Focus on next link
            else if (!event.shiftKey && navLinkContainer?.nextElementSibling?.firstElementChild) {
                event.preventDefault();
                navLinkContainer?.nextElementSibling?.firstElementChild?.focus();
            }
            else if (!event.shiftKey && !navLinkContainer?.nextElementSibling?.firstElementChild) {
                event.preventDefault();
                closeMenuOrSubmenu(navLinkContainer, parentSubmenuContainer, grandParentSubmenuContainer);
            }
        }
    } else {
        navLink?.addEventListener("keydown", event => {
            const pressedKeyCode = event.which || event.keyCode;

            // ESC key press
            if (pressedKeyCode === 27) {
                event.preventDefault();
                parentSubmenuContainer?.classList.remove("adm-ul-nav-mobile-opened");
                grandParentSubmenuContainer.style.overflow = '';
                setTimeout(() => {
                    navLinkContainer?.parentElement.previousElementSibling?.focus();
                }, 100);
            }
        })
    }
}

function closeSubmenuOrFocusOnPreviousLink(event, navLinkContainer, parentSubmenuContainer, grandParentSubmenuContainer) {
    // Close submenu after first link
    if (
        event.shiftKey &&
        !navLinkContainer?.previousElementSibling?.previousElementSibling &&
        !navLinkContainer?.parentElement.classList.contains("adm-ul-dropdown-nav-menu-mobile")
    ) {
        parentSubmenuContainer?.classList.remove("adm-ul-nav-mobile-opened");
        grandParentSubmenuContainer.style.overflow = '';
        setTimeout(() => {
            navLinkContainer?.parentElement.previousElementSibling?.focus();
        }, 100);
    }
    // Focus on previous link
    else {
        navLinkContainer?.previousElementSibling?.firstElementChild?.focus();
    }
}

function closeMenuOrSubmenu(navLinkContainer, parentSubmenuContainer, grandParentSubmenuContainer) {
    // Close entire menu after last link
    if (navLinkContainer?.parentElement.classList.contains("adm-ul-dropdown-nav-menu-mobile")) {
        closeSideNavMobile();
        openNavBtn.focus();
    }
    // Close submenu after last link
    else {
        parentSubmenuContainer?.classList.remove("adm-ul-nav-mobile-opened");
        grandParentSubmenuContainer.style.overflow = '';
        setTimeout(() => {
            navLinkContainer?.parentElement.previousElementSibling?.focus();
        }, 100);
    }
}

for (const l3Menu of sideNavContainer.querySelectorAll('.adm-ul-nav-mobile-l3')) {
    const l3Links = l3Menu.querySelectorAll("a")
    const menuOpener = l3Menu.previousElementSibling;

    const firstAndLastLinks = [l3Links[0], l3Links[l3Links.length - 1]];
    const grandParentSubmenuContainer = l3Menu.parentElement.parentElement;

    firstAndLastLinks.forEach((link, index) => {
        link.addEventListener("keydown", (event) => {
            const pressedKeyCode = event.which || event.keyCode;

            // Shift + TAB key press
            if (pressedKeyCode === 9 && (index === 0 ? event.shiftKey : !event.shiftKey)) {
                event.preventDefault();
                l3Menu?.classList.remove("adm-ul-nav-mobile-opened");
                grandParentSubmenuContainer.style.overflow = '';
                menuOpener?.focus();
            }
        })
    })
}

let sideNavL2Parents = [];
for (const l2Container of sideNavL2Containers) {
    sideNavL2Parents.push(l2Container.parentElement);
    l2Container.remove();
}

const addL2Links = () => {
    sideNavL2Parents.forEach((sideNavL2Parent, index) => {
        sideNavL2Parent.appendChild(sideNavL2Containers[index]);
    });
}

// Close side menu
window.addEventListener('click', function (e) {
    if (
        !sideNavContainer?.contains(e.target) &&
        !openNavBtn?.contains(e.target)
    ) {
        closeSideNavMobile();
    }
})

if (sideNavContainer) {
    setTimeout(() => {
        sideNavContainer.style.transition = "0.5s";
    }, 300);
}


// Fucntions
const closeSideNavMobile = () => {
    sideNavContainer?.classList.remove("adm-ul-nav-mobile-opened");
    sideNavContainer?.setAttribute("aria-hidden", "true")
    openNavBtn?.classList.remove("adm-btn-nav-mobile-active");
    sideNavContainer.style.overflow = '';
    for (const submenu of allSubmenus) {
        submenu.style.overflow = '';
        submenu?.classList.remove("adm-ul-nav-mobile-opened");
        openNavBtn?.children?.[0]?.classList.remove("adm-svg-nav-btn-mobile-hidden");
        openNavBtn?.children?.[0]?.classList.add("adm-svg-nav-btn-mobile-active");
        openNavBtn?.children?.[1]?.classList.add("adm-svg-nav-btn-mobile-hidden");
        openNavBtn?.children?.[1]?.classList.remove("adm-svg-nav-btn-mobile-active");
    }
    toggleSideNavLinks(sideNavAllLinks, "-1");
    toggleSideNavLinks(sideNavAllBtns, "-1");
}

const openSideNavMobile = () => {
    if (!isSideNavCreated) {
        isSideNavCreated = true;
        addL2Links();
    }
    sideNavContainer?.classList.add("adm-ul-nav-mobile-opened");
    sideNavContainer?.setAttribute("aria-hidden", "false")
    openNavBtn?.classList.add("adm-btn-nav-mobile-active");
    openNavBtn?.children?.[1]?.classList.remove("adm-svg-nav-btn-mobile-hidden");
    openNavBtn?.children?.[1]?.classList.add("adm-svg-nav-btn-mobile-active");
    openNavBtn?.children?.[0]?.classList.add("adm-svg-nav-btn-mobile-hidden");
    openNavBtn?.children?.[0]?.classList.remove("adm-svg-nav-btn-mobile-active");
    sideNavFirstLink?.focus();
    toggleSideNavLinks(sideNavAllLinks, "0");
    toggleSideNavLinks(sideNavAllBtns, "0");
}

const toggleSideNavLinks = (elements, tabindex) => {
    for (const elem of elements) {
        if (!elem.classList.contains("adm-btn-nav-mobile-back"))
            elem?.setAttribute("tabindex", tabindex);
        switch (tabindex) {
            case "0":
                elem?.setAttribute("aria-hidden", "false");
                break;
            case "-1":
                elem?.setAttribute("aria-hidden", "true");
                break;
        }
    }
}
toggleSideNavLinks(sideNavAllLinks, "-1");
toggleSideNavLinks(sideNavAllBtns, "-1");